import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

export type MessageNotice = {
  title: string;
  message: string;
};

type Props = {
  notice: MessageNotice | null;
  onClose: () => void;
};

export default function MessageDialog({ notice, onClose }: Props) {
  return (
    <Dialog open={notice !== null} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{notice?.title ?? ''}</DialogTitle>
          <DialogDescription>{notice?.message ?? ''}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={onClose}>OK</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
